// extracted by mini-css-extract-plugin
export default {"logo-container":"models-module__logo-container--xBMtP","logo-svg":"models-module__logo-svg--oC8to"};